import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {NgxBarcodeModule} from 'ngx-barcode';
import {routing} from './emergency.routing';
import {SafeUrlModule} from '../shared/custom-pipe/safe-url.module';
import {AutoCompleteModule, DialogModule} from 'primeng/primeng';
import {EmergencyComponent} from './emergency.component';
import {HttpModule} from '@angular/http';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LayoutModule} from '../layout/layout.module';
import {CollapseModule, ModalModule} from 'ngx-bootstrap';


@NgModule({
    imports: [
        CommonModule,
        routing,
        FormsModule,
        ReactiveFormsModule,
        NgxBarcodeModule,
        DialogModule,
        SafeUrlModule,
        HttpModule,
        SharedTranslationModule,
        AutoCompleteModule,
        BrowserAnimationsModule,
        LayoutModule,
        CollapseModule.forRoot(),
        ModalModule.forRoot(),

    ],
    declarations: [EmergencyComponent]
})
export class EmergencyModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/emergency/emergency.module.ts